import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-0.75 -0.75 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Multiple Users 3 Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M11.25 10.781v2.344M11.25 13.125l2.11 2.11M11.25 13.125l-2.11 2.11M9.14 2.578a2.11 2.11 0 1 0 4.22 0 2.11 2.11 0 1 0-4.22 0M15.469 8.906a4.354 4.354 0 0 0-8.438 0ZM2.578 15.703a2.11 2.11 0 1 0 4.219 0 2.11 2.11 0 1 0-4.219 0M8.906 22.031a4.354 4.354 0 0 0-8.437 0ZM15.703 15.703a2.11 2.11 0 1 0 4.219 0 2.11 2.11 0 1 0-4.219 0M22.031 22.031a4.354 4.354 0 0 0-8.437 0Z"
    }, null, -1)
  ])))
}
export default { render: render }